export default __webpack_public_path__ + "static/media/visitante-10k.12696254.png";